import React from 'react';
import FollowBrand from '@bnnvara/icons/src/components/AnimatedIcons/FollowBrand';
import Plus from '@bnnvara/icons/src/components/UserInterfaceIcons/Plus';
import PropTypes from 'prop-types';
import BaseButton from '../BaseButton';
import * as S from './styled';

const FollowBrandButton = ({
  color,
  isFollowedByUser,
  onClick
}) => {
  const text = isFollowedByUser ? 'Volgend' : 'Volgen';
  const button = isFollowedByUser ? /*#__PURE__*/React.createElement(S.LoadingContainer, null, /*#__PURE__*/React.createElement(FollowBrand, {
    isActive: isFollowedByUser,
    loop: "1"
  })) : /*#__PURE__*/React.createElement(Plus, null);
  return /*#__PURE__*/React.createElement(S.FollowBrandButton, {
    onClick: onClick,
    color: color
  }, /*#__PURE__*/React.createElement(BaseButton, {
    size: "small",
    variant: color === 'black' ? 'outline' : 'ghost',
    type: "button"
  }, /*#__PURE__*/React.createElement(S.SvgContainer, null, button), /*#__PURE__*/React.createElement(S.TextFollow, null, " ", text, " ")));
};

FollowBrandButton.propTypes = {
  isFollowedByUser: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string
};
FollowBrandButton.defaultProps = {
  color: 'white'
};
export default FollowBrandButton;